// libraries
import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

// auth
import Layout from '../../shared/components/layout';
import {getHiddenParams} from 'auth/utils';

// shared
import CredentialsInput from 'shared/auth/components/credentials-input';
import FormButton from 'shared/components/button';
import GoogleButton from 'shared/components/google-button';
import Separator from 'shared/components/separator';
import GoogleOAuth from 'shared/modules/google-oauth';

export default class Login extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    fields: PropTypes.shape({
      identifier: PropTypes.object.isRequired,
      password: PropTypes.object.isRequired
    }).isRequired,
    submitting: PropTypes.bool.isRequired,
    googleLogin: PropTypes.func.isRequired,
    setNavigationAnnouncement: PropTypes.func.isRequired
  }

  state = {
    params: getHiddenParams()
  }

  componentDidMount() {
    this.props.setNavigationAnnouncement('Log In');
    GoogleOAuth.init([]);
  }

  render() {
    const {
      handleSubmit,
      submitting,
      googleLogin,
      fields: {
        identifier,
        password
      }
    } = this.props;
    const {params} = this.state;

    return (
      <Layout page="login">
        <div className="auth-login auth-shared-credentials-container">
          <h1 className="auth-login-welcome-header">
            Welcome Back!
          </h1>
          <GoogleButton
            size="medium"
            buttonName="auth-login-google"
            modifierClass="auth-shared-google-button"
            onClick={googleLogin}
          >Log in with Google
          </GoogleButton>
          <Separator>or Log In with Email or Phone Number</Separator>
          <form onSubmit={handleSubmit}>
            <CredentialsInput identifier={identifier} password={password} />
            {params.eiid && <input type="hidden" name="eiid" value={params.eiid} />}
            {params.rej && <input type="hidden" name="rej" value={params.rej} />}
            {params.cpiid && <input type="hidden" name="cpiid" value={params.cpiid} />}
            {params.token && <input type="hidden" name="token" value={params.token} />}
            {params.next && <input type="hidden" name="next" value={params.next} />}
            <FormButton
              size="large"
              type="submit"
              modifierClass="auth-shared-submit-button"
              width="100%"
              disabled={submitting}
              id="desktop-login-submit-button"
            >{submitting ? 'Logging In...' : 'Log In'}
            </FormButton>
          </form>
          <a href="/forgot_password" className="auth-shared-link auth-login-forgot-password">
            Forgot your password?
          </a>
          <p className="auth-login-no-account">
            Don&#39;t have an account? <Link to="/signup" className="auth-shared-link">Sign up here</Link>
          </p>
        </div>
      </Layout>
    );
  }
}
